var _defs, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252a41;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    className: "cls-1",
    x: 18,
    y: 18,
    width: 16,
    height: 16,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    className: "cls-2",
    d: "M26,29l-3-5h6Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-2",
    "data-name": "Rectangle 84-2",
    className: "cls-1",
    x: 18,
    width: 16,
    height: 16,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5-2",
    "data-name": "Polygon 5-2",
    className: "cls-2",
    d: "M26,5l3,5H23Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-3",
    "data-name": "Rectangle 84-3",
    className: "cls-1",
    x: 36,
    y: 18,
    width: 16,
    height: 16,
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5-3",
    "data-name": "Polygon 5-3",
    className: "cls-2",
    d: "M47,26l-5,3V23Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-4",
    "data-name": "Rectangle 84-4",
    className: "cls-1",
    y: 18,
    width: 16,
    height: 16,
    rx: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5-4",
    "data-name": "Polygon 5-4",
    className: "cls-2",
    d: "M5,26l5-3v6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows01);
export default __webpack_public_path__ + "static/media/arrows_01.12865c1e.svg";
export { ForwardRef as ReactComponent };